// extracted by mini-css-extract-plugin
export default {"cardWithTabs":"Analytics_cardWithTabs__rJee2"};